export const getSinceDate = (date: Date) => {
  const createdAt = new Date(date);

  // Extract the month and year
  let month = createdAt.toLocaleString("es-ES", { month: "long" });
  const year = createdAt.getFullYear();

  // Capitalize the first letter of the month
  month = month.charAt(0).toUpperCase() + month.slice(1);

  // Format the output string
  return `Miembro desde: ${month} ${year}`;
};
